import { IContentSource } from "../../../domain/drawing";
import { AbstractSource } from "../../drawing";
import { LoggerFactory } from "../../../utilities/logger";

export class SectionThumbnailImageSource extends AbstractSource {
  constructor(getToken: () => string, public formatId: number, public key: string) {
    super(getToken);
  }

  protected getSource(): string {
    const url = "/api/format/" + this.formatId + "/thumbnail/" + this.key + "?token=" + this.token;
    SectionThumbnailImageSource._logger.debug("source: " + url);
    return url;
  }

  public clone(): IContentSource {
    return new SectionThumbnailImageSource(
      this._getToken,
      this.formatId,
      this.key
    );
  }

  private static readonly _logger = LoggerFactory.getLogger();
}
